const AREAS = [
  {
    icon: "ri-router-line",
    title: "Computer Networks",
    desc: "Enterprise routing, switching, SD-WAN, wireless, and campus/branch design engineered for uptime and scale.",
    tags: ["Cisco", "Juniper", "Aruba", "SD-WAN"],
  },
  {
    icon: "ri-server-line",
    title: "Data Center Infrastructure",
    desc: "From cabling plants and cooling to core switching, storage fabrics, and hybrid-cloud interconnect.",
    tags: ["Cabling", "Cooling", "Core switching"],
  },
  {
    icon: "ri-shield-keyhole-line",
    title: "High-Tech Security",
    desc: "Video surveillance, access control, intrusion detection, and unified security operations at facility scale.",
    tags: ["Access control", "Video", "SOC"],
  },
  {
    icon: "ri-cpu-line",
    title: "IoT & Connected Systems",
    desc: "Sensors, gateways, edge compute and telemetry — instrumented for real-world environments.",
    tags: ["Edge", "LoRa", "Zigbee", "5G"],
  },
  {
    icon: "ri-cloud-line",
    title: "Cloud & Hosting",
    desc: "Colocation, managed hosting, and cloud strategy — from dedicated iron to modern container platforms.",
    tags: ["Colo", "Managed", "Hybrid"],
  },
  {
    icon: "ri-team-line",
    title: "Advisory & Program Delivery",
    desc: "Standing up technology programs for government, enterprise and industry — with governance built in.",
    tags: ["PMO", "Governance", "Vendor mgmt"],
  },
];

export default function Expertise() {
  return (
    <section id="expertise" className="relative py-20 md:py-32 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.25em] text-primary-600 font-semibold mb-4">
            <span className="w-8 h-px bg-primary-500"></span>
            Expertise
          </div>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight tracking-tight">
            Where I do my <span className="text-primary-600">best work.</span>
          </h2>
          <p className="mt-4 md:mt-6 text-base md:text-lg text-foreground-700 leading-relaxed">
            A deep, hands-on stack across the physical, network, and security layers — plus
            the strategy and program muscle to actually ship things in complex organizations.
          </p>
        </div>

        <div className="mt-10 md:mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {AREAS.map((area, idx) => (
            <article
              key={area.title}
              className="group relative rounded-lg bg-background-50 border border-background-200 p-6 md:p-7 hover:border-primary-300 hover:-translate-y-1 transition-all duration-300"
            >
              <div className="flex items-start justify-between mb-4 md:mb-5">
                <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-md bg-primary-100 text-primary-700 group-hover:bg-primary-500 group-hover:text-background-50 dark:group-hover:text-foreground-950 transition-colors">
                  <i className={`${area.icon} text-2xl md:text-3xl`}></i>
                </div>
                <span className="font-mono text-xs text-foreground-400">
                  0{idx + 1}
                </span>
              </div>
              <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-950 leading-tight">
                {area.title}
              </h3>
              <p className="mt-3 text-sm md:text-base text-foreground-700 leading-relaxed">
                {area.desc}
              </p>
              <div className="mt-5 flex flex-wrap gap-2">
                {area.tags.map((t) => (
                  <span
                    key={t}
                    className="text-[11px] md:text-xs font-medium px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-900 whitespace-nowrap"
                  >
                    {t}
                  </span>
                ))}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}